
import { Vue } from 'vue-property-decorator';
export default class SavingNotification extends Vue {}
